import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import 'lib-flexible'
import Vant from 'vant';
import 'vant/lib/index.css';
import $ from 'jquery'
// import store from './store/index'
Vue.prototype.$ = $
Vue.use(Vant);
Vue.config.productionTip = false;

//加入健康码是否启用
Vue.prototype.$globalJKM = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");

1